import React from 'react';
import { usePrefixCls } from '@okee-uikit/react-config';
import { Dropdown } from '../../dropdown';
export function Item(props) {
  var _props$href = props.href,
      href = _props$href === void 0 ? '' : _props$href,
      index = props.index,
      icon = props.icon,
      _onClick = props.onClick,
      itemMaxWidth = props.itemMaxWidth,
      _props$active = props.active,
      active = _props$active === void 0 ? false : _props$active,
      _props$collapsed = props.collapsed,
      collapsed = _props$collapsed === void 0 ? false : _props$collapsed,
      children = props.children,
      _props$id = props.id,
      id = _props$id === void 0 ? "".concat(index) : _props$id,
      domRef = props.domRef,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  var cls = usePrefixCls('breadcrumb-item', {
    active: active,
    ellipsis: itemMaxWidth !== undefined
  });
  var contentCls = usePrefixCls('breadcrumb-item-content');
  var iconCls = usePrefixCls('breadcrumb-item-icon');

  if (!collapsed) {
    style.maxWidth = itemMaxWidth;
  }

  var Content = React.createElement("div", {
    className: cls,
    ref: domRef,
    style: style,
    onClick: function onClick() {
      if (href) {
        window.location.href = href;
      } else {
        !active && _onClick && _onClick(id);
      }
    }
  }, icon && React.createElement("span", {
    className: iconCls
  }, icon), children && React.createElement("span", {
    className: contentCls
  }, children));

  if (collapsed) {
    return React.createElement(Dropdown.MenuItem, {
      domRef: domRef,
      id: href,
      style: style
    }, Content);
  }

  return Content;
}